function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import defaultProps from '../default-props';

const UndrawOnline = _props => {
  const props = Object.assign({}, _props);
  const primaryColor = props.primaryColor || defaultProps.primaryColor;
  const style = Object.assign({
    height: props.height || defaultProps.height,
    width: '100%'
  }, props.style);
  delete props.primaryColor;
  delete props.height;
  delete props.style;
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: "1em",
    height: "1em",
    viewBox: "0 0 1082.19 847.94",
    style: style
  }, props), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "prefix__a",
    x1: 276.42,
    y1: 818,
    x2: 276.42,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), React.createElement("linearGradient", {
    id: "prefix__b",
    x1: 891.13,
    y1: 675.02,
    x2: 891.13,
    y2: 214.93,
    gradientTransform: "matrix(-1 0 0 1 1114 0)",
    xlinkHref: "#prefix__a"
  })), React.createElement("path", {
    d: "M909.2 36.16c37.27 12.37 51.62 19.46 88.51 32.93 15.11 5.52 30.64 11.41 42.27 22.52 12.21 11.67 18.87 27.95 23.58 44.17 10.1 34.82 12.19 74.1-5.42 105.79-16.11 29-47.49 49.78-54.54 82.18-5.2 23.89 4.26 48.17 8.9 72.17a184.8 184.8 0 0 1-6.35 93.79c-9.69 28.64-28.59 56.43-57.16 66.3-33.23 11.47-69.43-3.86-104.57-2.76-39.43 1.24-75.24 23.14-105.67 48.24s-57.89 54.24-91.65 74.55c-34.43 20.69-73.83 31.26-112.65 41.6-21.59 5.75-43.41 11.53-65.74 12.27-24.69.82-49.33-4.61-72.37-13.54-42.71-16.54-80.4-45.17-109.34-80.67-16.84-20.65-31.41-47.31-24.05-72.91 5.35-18.6 21-32 33-47.17 31.94-40.17 38.93-98.64 17.36-145.21-10.93-23.6-28.17-43.58-43.46-64.62s-29.13-44.43-31.5-70.33 9.64-54.65 33.65-64.64c29.45-12.24 71.25 3.84 90.26-21.78 7.2-9.71 8.12-22.5 10.32-34.38C384.29 51.68 444.1 1.12 508.1.02c49.92-.86 97 24.71 146.85 27.07 50.09 2.37 100.96-18.73 149.46-6.12 17.79 4.69 34.17 13.69 51.79 19s38 6.31 53.18-4.07",
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    fill: primaryColor,
    opacity: 0.1,
    d: "M492.93 182.79h437.49v30.27H492.93zM492.93 313.49h437.49v30.27H492.93zM492.93 449.69h437.49v30.27H492.93z"
  }), React.createElement("path", {
    fill: primaryColor,
    opacity: 0.1,
    d: "M655.27 104.38h27.51v78.42h-27.51z"
  }), React.createElement("path", {
    fill: primaryColor,
    opacity: 0.1,
    d: "M655.27 116.76h27.51v5.5h-27.51zM655.27 159.41h27.51v5.5h-27.51zM696.55 104.38h27.51v78.42h-27.51z"
  }), React.createElement("path", {
    fill: primaryColor,
    opacity: 0.1,
    d: "M696.55 116.76h27.51v5.5h-27.51zM696.55 159.41h27.51v5.5h-27.51zM737.82 104.38h27.51v78.42h-27.51z"
  }), React.createElement("path", {
    fill: primaryColor,
    opacity: 0.1,
    d: "M737.82 116.76h27.51v5.5h-27.51zM737.82 159.41h27.51v5.5h-27.51zM779.09 104.38h27.51v78.42h-27.51z"
  }), React.createElement("path", {
    fill: primaryColor,
    opacity: 0.1,
    d: "M779.09 116.76h27.51v5.5h-27.51zM779.09 159.41h27.51v5.5h-27.51zM765.725 381.552l24.591-12.331 35.15 70.101-24.591 12.33z"
  }), React.createElement("path", {
    fill: primaryColor,
    opacity: 0.1,
    d: "M771.276 392.623l24.592-12.33 2.465 4.916-24.592 12.33zM790.394 430.74l24.592-12.331 2.465 4.916-24.592 12.33zM785.97 236.45h27.51v78.42h-27.51z"
  }), React.createElement("path", {
    fill: primaryColor,
    opacity: 0.1,
    d: "M785.97 248.83h27.51v5.5h-27.51zM785.97 291.48h27.51v5.5h-27.51zM827.24 236.45h27.51v78.42h-27.51z"
  }), React.createElement("path", {
    fill: primaryColor,
    opacity: 0.1,
    d: "M827.24 248.83h27.51v5.5h-27.51zM827.24 291.48h27.51v5.5h-27.51zM868.51 236.45h27.51v78.42h-27.51z"
  }), React.createElement("path", {
    fill: primaryColor,
    opacity: 0.1,
    d: "M868.51 248.83h27.51v5.5h-27.51zM868.51 291.48h27.51v5.5h-27.51zM531.46 371.27h27.51v78.42h-27.51z"
  }), React.createElement("path", {
    fill: primaryColor,
    opacity: 0.1,
    d: "M531.46 383.65h27.51v5.5h-27.51zM531.46 426.3h27.51v5.5h-27.51zM572.73 371.27h27.51v78.42h-27.51z"
  }), React.createElement("path", {
    fill: primaryColor,
    opacity: 0.1,
    d: "M572.73 383.65h27.51v5.5h-27.51zM572.73 426.3h27.51v5.5h-27.51zM614 371.27h27.51v78.42H614z"
  }), React.createElement("path", {
    fill: primaryColor,
    opacity: 0.1,
    d: "M614 383.65h27.51v5.5H614zM614 426.3h27.51v5.5H614zM655.27 371.27h27.51v78.42h-27.51z"
  }), React.createElement("path", {
    fill: primaryColor,
    opacity: 0.1,
    d: "M655.27 383.65h27.51v5.5h-27.51zM655.27 426.3h27.51v5.5h-27.51zM696.55 371.27h27.51v78.42h-27.51z"
  }), React.createElement("path", {
    fill: primaryColor,
    opacity: 0.1,
    d: "M696.55 383.65h27.51v5.5h-27.51zM696.55 426.3h27.51v5.5h-27.51zM737.82 371.27h27.51v78.42h-27.51z"
  }), React.createElement("path", {
    fill: primaryColor,
    opacity: 0.1,
    d: "M737.82 383.65h27.51v5.5h-27.51zM737.82 426.3h27.51v5.5h-27.51z"
  }), React.createElement("g", {
    opacity: 0.1,
    fill: primaryColor
  }, React.createElement("path", {
    d: "M697.1 286.36s-8.34-2.83-12.36 4.52a13.41 13.41 0 0 0 .18 12.91c2.64 4.77 8.07 11 18.37 10.41 8.73-.47 11.64-7.13 12.43-13.33a13.7 13.7 0 0 0-18.19-14.66z"
  }), React.createElement("path", {
    d: "M686.66 304.45a13.41 13.41 0 0 1-.18-12.91c4-7.35 12.36-4.52 12.36-4.52l.43-.15a13.57 13.57 0 0 1 9.8.22 13.58 13.58 0 0 0-11.57-1.1l-.43.15s-8.34-2.83-12.36 4.52a13.41 13.41 0 0 0 .18 12.91 20 20 0 0 0 9.43 8.93 20.68 20.68 0 0 1-7.66-8.05z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M692.77 289.89s3.09 2.43 10.61 0",
    opacity: 0.2
  }), React.createElement("path", {
    d: "M692.1 272.22s5.3 14.36 4.86 18.12l4.2-.44s-7.07-12.59-5.3-17.68z"
  }), React.createElement("path", {
    d: "M692.1 272.22s5.3 14.36 4.86 18.12l4.2-.44s-7.07-12.59-5.3-17.68z",
    opacity: 0.2
  }), React.createElement("path", {
    d: "M713.75 273.42s-8.35-4.27-12.08-.74-4.31 12.54-4.31 12.54 13.61 1.87 16.39-11.8z"
  }), React.createElement("path", {
    d: "M713.75 273.42s-8.35-4.27-12.08-.74-4.31 12.54-4.31 12.54 13.61 1.87 16.39-11.8z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M697.36 285.22s2.19-10.46 16.39-11.8"
  })), React.createElement("g", {
    opacity: 0.1,
    fill: primaryColor
  }, React.createElement("path", {
    d: "M873.17 422.56s-8.34-2.83-12.36 4.52a13.41 13.41 0 0 0 .18 12.91c2.64 4.77 8.07 11 18.37 10.41 8.73-.47 11.64-7.13 12.43-13.33a13.7 13.7 0 0 0-18.19-14.66z"
  }), React.createElement("path", {
    d: "M862.76 440.65a13.41 13.41 0 0 1-.18-12.91c4-7.35 12.36-4.52 12.36-4.52l.43-.15a13.57 13.57 0 0 1 9.8.22 13.58 13.58 0 0 0-11.57-1.1l-.43.15s-8.34-2.83-12.36 4.52a13.41 13.41 0 0 0 .18 12.91 20 20 0 0 0 9.43 8.93 20.68 20.68 0 0 1-7.66-8.05z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M868.86 426.09s3.09 2.43 10.61 0",
    opacity: 0.2
  }), React.createElement("path", {
    d: "M868.2 408.42s5.3 14.36 4.86 18.12l4.2-.44s-7.07-12.59-5.3-17.68z"
  }), React.createElement("path", {
    d: "M868.2 408.42s5.3 14.36 4.86 18.12l4.2-.44s-7.07-12.59-5.3-17.68z",
    opacity: 0.2
  }), React.createElement("path", {
    d: "M889.84 409.62s-8.35-4.27-12.08-.74-4.31 12.54-4.31 12.54 13.65 1.87 16.39-11.8z"
  }), React.createElement("path", {
    d: "M889.84 409.62s-8.35-4.27-12.08-.74-4.31 12.54-4.31 12.54 13.65 1.87 16.39-11.8z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M873.46 421.41s2.19-10.46 16.39-11.8"
  })), React.createElement("path", {
    d: "M33.66 748.97S166.2 876.16 532.2 842.16s512-12 512-12 66-64-23-93-313-17-383-17-215-35-215-35z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M980.56 781.21s-21.72-110.07 23-185.51c18.77-31.66 27.41-68.35 23.45-104.94a285.89 285.89 0 0 0-10.46-51.23",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), React.createElement("path", {
    d: "M1044.46 391.82c-1.21 13.13-28.49 49-28.49 49s-20.28-40.27-19.08-53.41a23.88 23.88 0 1 1 47.56 4.37zM1077.1 468.19c-8.15 10.37-50.57 25.68-50.57 25.68s4.86-44.83 13-55.2a23.89 23.89 0 1 1 37.57 29.52zM1063.95 592.36c-12.27 4.84-56.61-3.36-56.61-3.36s26.83-36.24 39.1-41.08a23.883 23.883 0 1 1 17.51 44.44zM1032.85 684.07c-11.28 6.84-56.37 6.26-56.37 6.26s20.32-40.26 31.59-47.1a23.882 23.882 0 0 1 24.77 40.84zM976.35 491.83c8.58 10 51.6 23.53 51.6 23.53s-6.74-44.59-15.32-54.6a23.883 23.883 0 1 0-36.28 31.07zM941.35 599.55c11.18 7 56.28 7 56.28 7s-19.78-40.53-31-47.52a23.882 23.882 0 0 0-25.32 40.5zM921.69 708.92c9.84 8.78 54.28 16.42 54.28 16.42s-12.64-43.28-22.49-52.07a23.882 23.882 0 1 0-31.8 35.64z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M847.04 159.97l-14.77-6.14 19.76-47.55 14.77 6.14zm15.06-57.14a9.31 9.31 0 1 1 12.14-5.08 9.34 9.34 0 0 1-12.14 5.08zm40.21 80.08l-14.74-6.12 9.62-23.15c2.29-5.52 5.12-12.64-2.45-15.78s-11.35 2.31-13.92 8.51l-9.78 23.54-14.75-6.13 19.76-47.55 14.16 5.89-2.7 6.49.21.09c3.52-2.92 10-4.86 17.16-1.87 14.94 6.21 13.6 17.19 8.29 30l-10.85 26.12zM536.68 95.11l-5.87 15v61.28h20.86v11.07h11.74l11.07-11.07h17l22.81-22.81V95.11zm69.76 49.54l-13 13h-20.91l-11.07 11.12V157.7h-17.61v-54.73h62.58zm-13-26.73v22.79h-7.82v-22.74zm-20.86 0v22.79h-7.82v-22.74z",
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M493.89 695.71l-.47-40.27v-1.18l-6.35-540.39c0-.66 0-1.31-.06-2a53.87 53.87 0 0 0-2.15-12.74c-.1-.33-.19-.65-.29-1s-.2-.61-.31-.92-.26-.77-.4-1.15-.21-.55-.31-.83-.31-.8-.47-1.2l-.33-.78c-.17-.41-.35-.81-.53-1.21l-.35-.74q-.29-.6-.59-1.2l-.37-.72q-.31-.59-.64-1.18l-.39-.7c-.23-.39-.46-.78-.69-1.16l-.41-.67c-.25-.39-.5-.78-.76-1.16l-.42-.51c-.28-.41-.57-.81-.86-1.21l-.37-.51q-.63-.85-1.3-1.67a55.29 55.29 0 0 0-46.39-20.51l-274 16.12a55.49 55.49 0 0 0-18.42 4.29C96.48 92.68 58 119.1 58.92 166.86L69.23 725c.85 46.12 39.53 83 84.46 90.81a55.35 55.35 0 0 0 28.09.75l269.61-62.4a54.65 54.65 0 0 0 42.55-53.71z",
    transform: "translate(-58.9 -26.03)",
    fill: "url(#prefix__a)"
  }), React.createElement("path", {
    d: "M4.67 147.9l10.09 552.23c.94 51.45 48.94 91.34 99.71 91.34L91.76 59.3l-2 .51C47.75 70.42 3.74 96.83 4.67 147.9z",
    fill: "#535461"
  }), React.createElement("path", {
    d: "M4.67 147.9l10.09 552.23c.94 51.45 48.94 91.34 99.71 91.34L91.76 59.3l-2 .51C47.75 70.42 3.74 96.83 4.67 147.9z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M430.39 675.84a54 54 0 0 1-41.64 53.13L124.9 790.72a53.93 53.93 0 0 1-66.22-51.56l-.8-45.88v-.46l-2.5-141.19-7.59-430.05-.16-8.59a53.94 53.94 0 0 1 50.73-54.78l268.17-15.95a53.89 53.89 0 0 1 57 50c.09 1.05.13 2.13.14 3.21l6.21 534.69v2.76l.45 38.25z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M430.39 675.84a54 54 0 0 1-41.64 53.13L124.9 790.72a53.93 53.93 0 0 1-66.22-51.56l-.8-45.88v-.46l-2.5-141.19-7.59-430.05-.16-8.59a53.94 53.94 0 0 1 50.73-54.78l268.17-15.95a53.89 53.89 0 0 1 57 50c.09 1.05.13 2.13.14 3.21l6.21 534.69v2.76l.45 38.25z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M430.34 671.17L190.1 696.74l-18.4-613.1L411.92 62.5a53.65 53.65 0 0 1 11.74 33z",
    fill: primaryColor
  }), React.createElement("path", {
    fill: primaryColor,
    d: "M429.89 632.92l-372.02 59.9-2.5-141.18 129.87-17.37 244.65 98.65z"
  }), React.createElement("path", {
    fill: "#fff",
    opacity: 0.1,
    d: "M429.89 632.92l-372.02 59.9-2.5-141.18 129.87-17.37 244.65 98.65z"
  }), React.createElement("path", {
    d: "M430.39 675.84a54 54 0 0 1-41.64 53.13L124.9 790.72a53.93 53.93 0 0 1-66.22-51.56l-.8-45.88 372-63.13v2.76l.45 38.25zM423.51 92.26L47.78 121.58l-.16-8.59a53.94 53.94 0 0 1 50.73-54.78l268.18-15.95a53.89 53.89 0 0 1 57 50z",
    fill: "#535461"
  }), React.createElement("circle", {
    cx: 262.48,
    cy: 711.22,
    r: 26.31,
    fill: "#fff"
  }), React.createElement("path", {
    fill: "#fff",
    d: "M271.69 78.69l-44.73 2.32v-2.63l44.73-2.32v2.63z"
  }), React.createElement("rect", {
    x: 17.66,
    y: 180.71,
    width: 16,
    height: 51.88,
    rx: 8,
    ry: 8,
    fill: "#fff"
  }), React.createElement("circle", {
    cx: 215.12,
    cy: 81.01,
    r: 2.63,
    fill: "#fff"
  }), React.createElement("path", {
    d: "M134.24 288.67a11.36 11.36 0 0 0 6.7 6.25c1.33.43 2.73.58 4.08.91 6.45 1.61 11 7.19 16.9 10.27a3.25 3.25 0 0 0 1.56.48h.2a1.92 1.92 0 0 0 .37 0 3.13 3.13 0 0 0 1.65-.69l.26-.2a19.78 19.78 0 0 1 .29 8c-2.34 0-17.49.93-15.42 18.83 2.25 19.38 24.72 46.52 24.72 46.52s15.73 16.06 10.67 70.89l-.56 26.58s6-.91 13.75-1.82q.27.53.55 1a41.39 41.39 0 0 0 8.3 10.26l12.79 30.39s1.1 2 2.72 5.1c.15 6.44-3.85 12.07-3.85 12.07-24.72 7.2-34.83 33.23-34.83 33.23s-14 8.36-17 17.67c-5.89 4.77-5.49 17.78-5.49 17.78s20.79 11.08 36 17.17a25 25 0 0 0 5.47 1.5l-3.38 7c-3.52 1.27-3.78 18.67-3.78 18.67s37.08 26.58 48.31 28.25 20.79-6.09 9-11.63c-9.5-4.46-20.1-21.5-23.86-28 4.7-6.45 19.54-27.35 20.49-35.73C252 589.5 266 581.19 266 581.19c20.22-21.6 6.74-47.08 5.06-60.37 0-.25-.07-.53-.12-.83a145.4 145.4 0 0 0-4.75-17c2.21-13.94 4-35.71 5-50.08 4.46 1.44 8.83 3.13 8.83 3.13 8.2-16.65-19.66-85.2-27.68-104.2 4.68-1.55 12.74-4 24.31-6.56 19.66-4.43 20.79-14.4 20.79-14.4l15.17-41c-1.29.58-3.27.55-5.59.15v-1.11c.12-3.89.49-10.1 1.63-11.23 0 0-3.73 0-8.26-.4v-.55l2-25.07s-2.81-27.69-12.36-23.82c-7.67 3.11-6.64 28-5.94 37.69a16.81 16.81 0 0 0 2.13 7l.64 1.14.44.78a9.44 9.44 0 0 1-1.21-.69v8.58c-1.06-.51-1.69-.82-1.69-.82.56 9.42-11.24 41-11.24 41s-20.79-2.22-27.53 2.22c-4.94 3.25-11.4-3-14.49-6.61l14.49-31.6a41.43 41.43 0 0 1-5.17-1.26c.06-.38.14-.79.21-1.21.74-4 2.06-9.56 3.84-10.26a63 63 0 0 0-8-3.66c.06-.32.13-.66.21-1 1.05-5.54 2.7-17.51-.65-25.77-4.49-11.08-6.18-32.68-14.61-27.69-6.69 4-7 27.79-6.85 37.46a16.61 16.61 0 0 0 1.92 7.51l3.25 6.15.45.85-.45.08v7.57c-1.42-.9-2.25-1.47-2.25-1.47-.28 10.65-7.33 24.84-14.22 36.26l-3.5-2.52-.86-.62a2.14 2.14 0 0 1 0-.33s-1.44-.41-3.72-.87c-2.83-5.37-4.41-11.85-5.29-17.23-.09-.56-.17-1.11-.25-1.64a22.35 22.35 0 0 0 2-9.17 22.81 22.81 0 0 0-19.26-22.4c.69-.77 1-1 1.2-1h.15a4.17 4.17 0 0 0 2.54-.68c1.78-.87 3.79-2.16 3.78-4.11 0-1.43-1.14-2.61-2.34-3.42-2.9-1.94-3-5.29-5.68-5a3.58 3.58 0 0 0-1.53.2c-2.47.81-4.62 2.36-7 3.34a16.64 16.64 0 0 1-5.28 1.2 21.85 21.85 0 0 0-3.46.27 10.16 10.16 0 0 0-2.61 1.06c-5.08 2.77-10.93 7-12.56 12.47-1.53 5.14.59 11.81-3.35 15.51a14.5 14.5 0 0 0-2 1.89 6.56 6.56 0 0 0-1 2.52 15.11 15.11 0 0 0 .95 9.1zM237 555c.21 2.65-.29 4.53-1.84 5.14-8.43 3.32-18 33.78-18 33.78l-6.39 13.19a170 170 0 0 1-14.53-12.29l.69-4.77s18-13.29 19.1-17.17c.89-3.13 15.42-13.88 20.97-17.88z",
    transform: "translate(-58.9 -26.03)",
    fill: "url(#prefix__b)"
  }), React.createElement("path", {
    d: "M190.6 322.34s38.2 88.42 28.93 107.52c0 0-15.28-6-17.47-4.91s-24-114.07-24-114.07z",
    fill: "#c4c8e2"
  }), React.createElement("path", {
    d: "M190.6 322.34s38.2 88.42 28.93 107.52c0 0-15.28-6-17.47-4.91s-24-114.07-24-114.07z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M169.86 603.97s13.1 24.56 24.56 30 2.18 13.1-8.73 11.46-46.94-27.84-46.94-27.84.25-17.15 3.67-18.4 27.44 4.78 27.44 4.78zM135.47 564.12s18.56 18.56 26.74 20.19-7.1 12.55-21.83 6.55-34.93-16.89-34.93-16.89-.55-17.47 8.73-19.1 21.29 9.25 21.29 9.25z",
    fill: "#4c495a"
  }), React.createElement("path", {
    d: "M211.88 412.39s-3.78 66.58-8.78 75.87-23.47 37.66-23.47 37.66-21.29 15.28-22.38 19.1-18.5 16.95-18.5 16.95l-1.09 7.64s-28.93-1.64-27.29-11.46 16.92-19.18 16.92-19.18 9.81-25.61 33.81-32.7c0 0 7.64-10.92 1.09-19.65 0 0-16.37-40.93-25.65-45.85s3.82-33.29 3.82-33.29z",
    fill: "#5f5d7e"
  }), React.createElement("path", {
    d: "M211.88 412.39s-3.78 66.58-8.78 75.87-23.47 37.66-23.47 37.66-21.29 15.28-22.38 19.1-18.5 16.95-18.5 16.95l-1.09 7.64s-28.93-1.64-27.29-11.46 16.92-19.18 16.92-19.18 9.81-25.61 33.81-32.7c0 0 7.64-10.92 1.09-19.65 0 0-16.37-40.93-25.65-45.85s3.82-33.29 3.82-33.29z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M158.4 565.76l-17.47 36.57c2.73 9.28 28.93 6 28.93 6s20.24-27.29 21.24-37.11 14.74-18 14.74-18c19.65-21.29 6.55-46.39 4.91-59.49 0-.25-.07-.52-.12-.81-1.45-8.78-10.28-34.06-17.15-53-4.63-12.75-8.38-22.62-8.38-22.62s-36.57 1.64-44.21 14.74c-3.5 6-1.93 12.24.79 17.25a40.65 40.65 0 0 0 8.07 10.11l12.43 30s21.83 39.84 13.64 43.12-17.42 33.24-17.42 33.24z",
    fill: "#5f5d7e"
  }), React.createElement("path", {
    d: "M223.57 242.14a16.74 16.74 0 0 0 2.07 6.95l.62 1.12 3.08 5.55h9.82l.21-2.58 2-24.71s-2.73-27.29-12-23.47c-7.47 3.06-6.48 27.58-5.8 37.14z",
    fill: "#fdc2cc"
  }), React.createElement("path", {
    d: "M226.27 250.21l3.08 5.55h9.82l.21-2.58c-4.57-.41-10.02-1.21-13.11-2.97z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M225.53 250.3v12.55l20.19 5.46s0-1.3.05-3.13c.11-3.83.47-10 1.58-11.06.01 0-16.37 0-21.82-3.82z",
    fill: "#eaeaf3"
  }), React.createElement("path", {
    d: "M225.53 257.66v5.19l20.19 5.46s0-1.3.05-3.13c-6.67-1.21-16.42-5.67-20.24-7.52z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M107.74 278.37c4 11.51-1.2 16.68-1.2 16.68s49.12 3.27 37.11-5.46c-7-5.1-10.12-16.35-11.48-24.82a84.65 84.65 0 0 1-1.07-10.65s-39.25-.58-31.11 10.37a52.55 52.55 0 0 1 7.75 13.88z",
    fill: "#fdc2cc"
  }), React.createElement("path", {
    d: "M100 264.49c4 5.38 5.31 6.17 6.65 10.06a21.94 21.94 0 0 0 3.72.31c9.36 0 18.47-1.93 21.81-10.09a84.65 84.65 0 0 1-1.08-10.65s-39.25-.58-31.1 10.37z",
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 111.45,
    cy: 254.12,
    r: 22.38,
    fill: "#fdc2cc"
  }), React.createElement("path", {
    d: "M223.89 257.97s21.29 10.92 27.29 8.19l-14.74 40.39s-1.09 9.82-20.19 14.19-28.38 8.19-28.38 8.19l-35.48-42 18 4.91s9.28 13.1 15.83 8.73 26.74-2.18 26.74-2.18 11.48-31.17 10.93-40.42z",
    fill: "#c4c8e2"
  }), React.createElement("path", {
    d: "M223.89 257.97s21.29 10.92 27.29 8.19l-14.74 40.39s-1.09 9.82-20.19 14.19-28.38 8.19-28.38 8.19l-35.48-42 18 4.91s9.28 13.1 15.83 8.73 26.74-2.18 26.74-2.18 11.48-31.17 10.93-40.42z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M140.93 283.7s-28.85-8.25-31.89 7.08c0 0 13.33-6.5 32.44 5 1.43.86 2.83 1.78 4.2 2.74 16.81 11.78 28.55 30 33.27 50.71l12.15 53.41 1.13 14.33s17.47 3.45 20.74-1.72 1.09-22.41-3.82-28.15-12.55-30.43-12.55-30.43l-4.78-14.33a95.85 95.85 0 0 0-18.72-32.78l-1.15-1.39a71.66 71.66 0 0 0-26.61-19.9c-2.77-1.23-4.79-2.76-4.41-4.57z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M140.93 282.61s-28.85-8.25-31.89 7.08c0 0 13.33-6.5 32.44 5 1.43.86 2.83 1.78 4.2 2.74 16.81 11.78 28.55 30 33.27 50.71l12.15 53.4 1.09 14.36s17.47 3.45 20.74-1.72 1.09-22.41-3.82-28.15-12.55-30.45-12.55-30.45l-4.78-14.33a95.85 95.85 0 0 0-18.68-32.79l-1.15-1.39a71.66 71.66 0 0 0-26.61-19.9c-2.77-1.2-4.79-2.75-4.41-4.56z",
    fill: "#eaeaf3"
  }), React.createElement("path", {
    d: "M213.49 392.63l-.24 9.4-7.64-4.91s-13.61-49.53-23.2-63c-1.13-1.59-1.68-4-2.73-4.37l-39-37.66v-8.73s19.92 14.74 21.56 17.47c.7 1.16 11.16 6.88 17.47 15.83a197.85 197.85 0 0 1 15 25.92l13.08 29.39z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M140.66 282.77v8.46l39.57 37.93c1.05.4 1.6 2.78 2.73 4.37 9.59 13.51 23.2 63 23.2 63l7.64 4.91.24-9.4-5.7-20.62-13.1-29.45a197.8 197.8 0 0 0-15-25.92c-6.3-9-16.77-14.67-17.47-15.83-1.41-2.35-16.8-13.62-21-16.69z",
    fill: "#d39999"
  }), React.createElement("rect", {
    x: 163.19,
    y: 153.16,
    width: 78,
    height: 78,
    rx: 11.17,
    ry: 11.17,
    fill: primaryColor
  }), React.createElement("rect", {
    x: 163.19,
    y: 153.16,
    width: 78,
    height: 78,
    rx: 11.17,
    ry: 11.17,
    fill: "#fff",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M202.2 175.81a16.36 16.36 0 1 0 16.36 16.36 16.33 16.33 0 0 0-16.36-16.36zm0 27a10.63 10.63 0 1 1 10.63-10.63 10.65 10.65 0 0 1-10.63 10.63zm20.84-27.66a3.82 3.82 0 1 1-3.82-3.82 3.81 3.81 0 0 1 3.83 3.81zm10.84 3.82c-.24-5.11-1.41-9.64-5.15-13.37s-8.26-4.9-13.37-5.15c-5.27-.3-21.06-.3-26.32 0-5.1.24-9.62 1.41-13.37 5.14s-4.9 8.26-5.15 13.37c-.3 5.27-.3 21.06 0 26.32.24 5.11 1.41 9.64 5.15 13.37s8.26 4.9 13.37 5.15c5.27.3 21.06.3 26.32 0 5.11-.24 9.64-1.41 13.37-5.15s4.9-8.26 5.15-13.37c.3-5.27.3-21 0-26.31zm-6.78 32a10.77 10.77 0 0 1-6.06 6.06c-4.2 1.67-14.17 1.28-18.81 1.28s-14.62.37-18.81-1.28a10.77 10.77 0 0 1-6.06-6.06c-1.67-4.2-1.28-14.17-1.28-18.81s-.37-14.62 1.28-18.81a10.77 10.77 0 0 1 6.06-6.06c4.2-1.67 14.17-1.28 18.81-1.28s14.62-.37 18.81 1.28a10.77 10.77 0 0 1 6.06 6.06c1.67 4.2 1.28 14.17 1.28 18.81s.36 14.62-1.28 18.81z",
    opacity: 0.2
  }), React.createElement("path", {
    d: "M118.91 230.36c1.73-.85 3.68-2.13 3.67-4.05a4.45 4.45 0 0 0-2.28-3.34c-3.12-2.12-2.88-6-6.46-4.77-2.4.8-4.49 2.32-6.83 3.29a16 16 0 0 1-5.13 1.19 20.93 20.93 0 0 0-3.37.27 9.79 9.79 0 0 0-2.54 1 21.92 21.92 0 0 0-10.31 12.86c-1.48 5.07-1.33 11.07-5.15 14.71a14.19 14.19 0 0 0-1.9 1.86 6.51 6.51 0 0 0-1 2.49 15.09 15.09 0 0 0 .75 9.06 11.1 11.1 0 0 0 6.51 6.16c1.29.42 2.65.57 4 .9 6.27 1.58 10.71 7.08 16.42 10.12a3.13 3.13 0 0 0 1.52.48 3 3 0 0 0 1.6-.68c2.21-1.58 4-4 4-6.74a13.63 13.63 0 0 0-1.46-4.86 47.09 47.09 0 0 1-2.73-8.79 4.29 4.29 0 0 1-.06-2.13c.41-1.32 1.88-1.94 2.9-2.88 1.94-1.8 2.17-4.84 1.45-7.38s-2.21-4.78-3.33-7.17a5.65 5.65 0 0 1-.66-2.33c0-3.19 4.31-4.92 6.13-7 2.45-2.88.89-.6 4.26-2.27z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M118.36 230.36c1.73-.85 3.68-2.13 3.67-4.05a4.45 4.45 0 0 0-2.28-3.37c-3.12-2.12-2.88-6-6.46-4.77-2.4.8-4.49 2.32-6.83 3.29a16 16 0 0 1-5.13 1.19c-1.13.07-4.77-1.65-5.87-1.4a9.79 9.79 0 0 0-2.54 1 21.92 21.92 0 0 0-10.31 12.86c-1.48 5.07-.45 11.4-4.27 15-.64.61.23 2.47-.29 3.19a6.51 6.51 0 0 0-1 2.49 15.09 15.09 0 0 0 .75 9.06 11.1 11.1 0 0 0 6.51 6.16c1.29.42 2.65.57 4 .9 6.27 1.58 10.71 7.08 16.42 10.12a3.13 3.13 0 0 0 1.52.48 3 3 0 0 0 1.6-.68c2.21-1.58 4-4 4-6.74a13.63 13.63 0 0 0-1.46-4.86 47.09 47.09 0 0 1-2.73-8.79 4.29 4.29 0 0 1-.06-2.13c.41-1.32 1.88-1.94 2.9-2.88 1.94-1.8 2.17-4.84 1.45-7.38s-2.21-4.78-3.33-7.17a5.65 5.65 0 0 1-.66-2.33c0-3.19 4.31-4.92 6.13-7 2.46-2.8.9-.52 4.27-2.19z",
    fill: "#865a61"
  }), React.createElement("path", {
    d: "M141.72 449.29c10-1.18 22.6-2.34 28.14-1.42 8.91 1.48 21.41-6.46 23.66-7.95-4.63-12.75-8.38-22.62-8.38-22.62s-36.57 1.64-44.21 14.74c-3.5 6-1.93 12.24.79 17.25z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M93.99 308.15c2.18 19.1 24 45.85 24 45.85s15.28 15.83 10.37 69.86l-.55 26.2s32.2-4.91 42-3.27 24-8.19 24-8.19 5.46-94.42-18-114.07a138.64 138.64 0 0 0-9.43-12.83c-6.3-7.63-14.87-16.22-22.88-18.34a14.32 14.32 0 0 0-3.16-.49s-24.56-13.64-31.11-3.27c.04-.01-17.42-.55-15.24 18.55z",
    fill: "#c4c8e2"
  }), React.createElement("path", {
    d: "M193.6 409.97s-8.73-3.82-23.47-2.73-41-12-41-12",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M177.77 531.65s-.55 1.64 6.55 3.82 9.28 4.37 9.28 4.37",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M156.1 229.91a16.56 16.56 0 0 0 1.87 7.4l3.13 6.06 2.18 4.2 13.64 1.09s.28-1.12.63-3c1-5.46 2.63-17.25-.63-25.4-4.37-10.92-6-32.2-14.19-27.29-6.46 3.92-6.77 27.41-6.63 36.94z",
    fill: "#fdc2cc"
  }), React.createElement("path", {
    d: "M161.1 243.2v.17l2.18 4.2 13.64 1.09s.28-1.12.63-3c-4.85-1.88-11.25-3.61-16.45-2.46z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M161.1 244.29v9.82l19.65 10.37s.22-1.78.64-4.08c.71-3.95 2-9.43 3.73-10.11-.02.01-14.17-8.18-24.02-6z",
    fill: "#eaeaf3"
  }), React.createElement("path", {
    d: "M107.99 333.5a23.12 23.12 0 0 0 17.65 5.65c34.55-3.51 35.49-15.72 35.49-15.72l5.31-11.74c-6.3-7.63-14.87-16.22-22.88-18.34-5.73 9.23-10.8 15.89-10.8 15.89s-25.65-19.65-33.29-1.09c-4.47 10.82 2.18 19.76 8.52 25.35z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M161.1 250.31v3.81l19.65 10.37s.22-1.78.64-4.08c-8.44-2.72-16.82-7.86-20.29-10.1z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M158.94 250.3s14.74 10.37 27.29 12.55l-25.65 56.76s-.94 12.21-35.49 15.72a23.13 23.13 0 0 1-17.65-5.65c-6.33-5.6-13-14.55-8.53-25.35 7.64-18.56 33.29 1.09 33.29 1.09s26.2-34.38 26.74-55.12z",
    fill: "#c4c8e2"
  }), React.createElement("path", {
    d: "M369.3 162.97v2c0 20.59-15.67 44.32-44.32 44.32a44 44 0 0 1-23.92-7 32.22 32.22 0 0 0 3.76.19 31.2 31.2 0 0 0 19.34-6.65 15.6 15.6 0 0 1-14.56-10.8 19.64 19.64 0 0 0 2.94.24 16.47 16.47 0 0 0 4.1-.53 15.58 15.58 0 0 1-12.49-15.29v-.19a15.69 15.69 0 0 0 7 2 15.6 15.6 0 0 1-4.82-20.83 44.28 44.28 0 0 0 32.12 16.3 17.58 17.58 0 0 1-.39-3.57 15.59 15.59 0 0 1 27-10.66 30.67 30.67 0 0 0 9.89-3.76 15.53 15.53 0 0 1-6.85 8.58 31.23 31.23 0 0 0 9-2.41 33.48 33.48 0 0 1-7.8 8.06zM310.74 325.12v58.71a3.64 3.64 0 0 1-3.64 3.64h-16.83v-25.55h8.57l1.26-9.95h-9.87v-6.36c0-2.89.8-4.85 4.94-4.85h5.27v-8.91a70.91 70.91 0 0 0-7.69-.4c-7.6 0-12.82 4.64-12.82 13.17v7.35h-8.6v10h8.6v25.56h-31.55a3.65 3.65 0 0 1-3.64-3.64v-58.77a3.65 3.65 0 0 1 3.64-3.64h58.72a3.65 3.65 0 0 1 3.64 3.64z",
    opacity: 0.2
  }), React.createElement("path", {
    d: "M621.82 246.87a13.31 13.31 0 0 0-9.89-8.88c-8.38-1.76-41.45.11-41.45.11s-33.08 1.87-41.2 4.56a13.31 13.31 0 0 0-8.82 9.94c-1.74 8.43-.76 25.75-.76 25.75s1 17.32 3.66 25.5a13.11 13.11 0 0 0 9.88 8.73c8.38 1.76 41.45-.11 41.45-.11s33.08-1.87 41.2-4.56a13.11 13.11 0 0 0 8.83-9.79c1.74-8.43.76-25.75.76-25.75s-.98-17.32-3.66-25.5zm-59.16 44.84l-1.78-31.46 28.54 14.16-26.76 17.29z",
    fill: primaryColor,
    opacity: 0.1
  }));
};

UndrawOnline.propTypes = {
  height: PropTypes.string,
  primaryColor: PropTypes.string
};
export default UndrawOnline;